var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-media-list-component" }, [
    _c("div", { staticClass: "room-media-list" }, [
      _c("div", { staticClass: "room-media-list-header" }, [
        _c("div", { staticClass: "room-media-list-header-title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("media.list.title")))]),
          _c(
            "button",
            {
              staticClass: "room-media-codec-info-btn",
              on: {
                click: function ($event) {
                  _vm.isShowCodecInfo = !_vm.isShowCodecInfo
                },
                blur: function ($event) {
                  _vm.isShowCodecInfo = false
                },
              },
            },
            [
              _vm.isShowCodecInfo
                ? _c("div", { staticClass: "room-media-codec-info" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("media.list.forms")))]),
                    _c("p", { staticClass: "codec-list-tx" }, [
                      _vm._v("mp3, mp4(H.264), WebM(VP8, VP9), ogg"),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _c("div", { staticClass: "room-media-list-header-button-container" }, [
          _c("button", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right",
                value: _vm.$t("media.list.repeat"),
                expression: "$t('media.list.repeat')",
                modifiers: { right: true },
              },
            ],
            staticClass: "room-media-list-header-button repeat",
            class: _vm.repeatClass,
            on: { click: _vm.onChangeRepeat },
          }),
          _c("button", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right",
                value: _vm.$t("media.list.hide"),
                expression: "$t('media.list.hide')",
                modifiers: { right: true },
              },
            ],
            staticClass: "room-media-list-header-button close",
            on: { click: _vm.onToggleMediaList },
          }),
        ]),
      ]),
      _c("div", { staticClass: "room-media-list-body" }, [
        _c("div", { staticClass: "room-media-list-body-button-wrapper" }, [
          _vm.hasEmceeRole()
            ? _c(
                "button",
                {
                  staticClass: "room-media-list-body-button add",
                  on: { click: _vm.onUploadFile },
                },
                [_vm._v(_vm._s(_vm.$t("media.list.add")))]
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "room-media-file" }, [
          _c(
            "ul",
            { staticClass: "room-media-file-list" },
            _vm._l(
              _vm.sortedRoomMediaFile(_vm.roomMedia),
              function (roomMediaFile) {
                return _c(
                  "li",
                  {
                    key: roomMediaFile.mediaId,
                    staticClass: "room-media-file-item",
                    class: {
                      play:
                        _vm.roomMedia.mediaId == roomMediaFile.mediaId &&
                        _vm.isRoomMode("media"),
                    },
                    attrs: { mediaId: roomMediaFile.mediaId },
                  },
                  [
                    _c("div", { staticClass: "room-media-file-info" }, [
                      _c("div", { staticClass: "room-media-file-start" }, [
                        _c("p", { staticClass: "room-media-file-title" }, [
                          _vm._v(_vm._s(roomMediaFile.mediaName)),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "room-media-file-end",
                          class: { "px-2": !_vm.hasEmceeRole() },
                        },
                        [
                          _c("p", { staticClass: "room-media-file-time" }, [
                            _vm._v(_vm._s(_vm.getDuration(roomMediaFile))),
                          ]),
                          _vm.hasEmceeRole()
                            ? _c("button", {
                                staticClass: "room-media-file-button remove",
                                on: {
                                  click: function ($event) {
                                    return _vm.onRemoveRoomMediaFile(
                                      roomMediaFile
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _c("button", {
                      staticClass: "room-media-file-button start",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoomMediaFile(roomMediaFile)
                        },
                      },
                    }),
                  ]
                )
              }
            ),
            0
          ),
          _c(
            "ul",
            _vm._l(_vm.uploadRoomMediaFiles, function (mediaFile) {
              return _c(
                "li",
                { key: mediaFile.id, staticClass: "room-media-file-item" },
                [
                  _c("div", { staticClass: "room-media-file-info" }, [
                    _c("div", { staticClass: "room-media-file-start" }, [
                      _c("p", { staticClass: "room-media-file-title" }, [
                        _vm._v(_vm._s(mediaFile.filename)),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "room-media-file-end",
                        class: { "px-2": !_vm.hasEmceeRole() },
                      },
                      [
                        _c("div", { staticClass: "room-media-file-progress" }, [
                          _c("div", {
                            staticClass: "room-media-file-progress-bar",
                            style: _vm.mediaFileProgressBar(mediaFile),
                          }),
                        ]),
                        _vm.hasEmceeRole()
                          ? _c("button", {
                              staticClass: "room-media-file-button remove",
                              on: {
                                click: function ($event) {
                                  return _vm.onRemoveUploadMediaFile(mediaFile)
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }